var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('datatable-plano')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }